import pageTitle from 'ember-page-title/helpers/page-title';
import t from 'ember-intl/helpers/t';
import { LinkTo } from '@ember/routing';
import PrintCourse from '../components/print-course';
import { and } from 'ember-truth-helpers';
<template>
  {{pageTitle (t "general.courses") " | " @model.title " (" (t "general.printSummary") ")"}}
  <div class="backtolink">
    <LinkTo @route="course" @model={{@model}}>
      {{t "general.backToCourse"}}
    </LinkTo>
  </div>
  <PrintCourse
    @course={{@model}}
    @includeUnpublishedSessions={{and @controller.unpublished @controller.canViewUnpublished}}
  />
</template>
